import UIActions, { UIAction } from './actions'
import mergeAppCounters from './mergeAppCounters'
import { UIState } from './types'

const UIReducer = (UIState: UIState | never, action: UIAction): UIState | never => {
    switch (action.type) {
        case UIActions.STORE_APPLICATIONS: {
            return { ...UIState, apps: action.payload }
        }
        case UIActions.UPDATE_APP_COUNTERS: {
            return { ...UIState, apps: mergeAppCounters(UIState.apps, action.payload) }
        }
        case UIActions.TOGGLE_SENSITIVE_CONTENT: {
            return { ...UIState, sensitiveContentVisible: !UIState.sensitiveContentVisible }
        }
        case UIActions.STORE_APPLICATION_SETTINGS: {
            return { ...UIState, appSettings: action.payload }
        }
    }
}

export default UIReducer
